import { ShamDashboardData } from 'sham-components/features/dashboard';
import {
  ShamDashboardSquare01StrokeIcon,
  ShamWhiteboardIcon,
  ShamPackage03Icon,
  ShamInvoice02Icon,
  ShamCalculateIcon,
  ShamSettingsIcon,
  ShamStore01Icon,
  ShamAccountantCollectionCashIcon,
  ShamAccountantCustomerPayoutsIcon,
} from 'sham-components/icons';

export async function dashboardLayoutDataFactory(
  dashData: ShamDashboardData,
  translate: any,
) {
  dashData.navLinks.set([
    {
      name: translate.instant('menu.dashboard'),
      paths: 'dashboard',
      icon: ShamDashboardSquare01StrokeIcon,
    },
    {
      name: translate.instant('menu.subOrders'),
      paths: 'sub-orders',
      icon: ShamPackage03Icon,
    },
    {
      name: translate.instant('menu.mainOrders'),
      paths: 'main-orders',
      icon: ShamInvoice02Icon,
    },
    {
      name: translate.instant('menu.taxInformation'),
      paths: 'tax-information',
      icon: ShamCalculateIcon,
    },
    {
      name: translate.instant('menu.sellerPayouts'),
      paths: 'seller-payouts',
      icon: ShamStore01Icon,
    },
    {
      name: translate.instant('menu.customerWalletPayouts'),
      paths: 'customer-wallet-payouts',
      icon: ShamAccountantCustomerPayoutsIcon,
    },
    {
      name: translate.instant('menu.collectionCash'),
      paths: 'collection-cash',
      icon: ShamAccountantCollectionCashIcon,
    },
    {
      name: translate.instant('menu.sellersSummary'),
      paths: 'sellers-summary',
      icon: ShamWhiteboardIcon,
    },
    {
      name: 'General Settings',
      paths: 'general-settings',
      icon: ShamSettingsIcon,
    },
  ]);
}
